function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "81",
  viewBox: "0 0 82 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1.167",
  y: ".5",
  width: "80.333",
  height: "65",
  rx: "3.5",
  fill: "#FAFAFA",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "6.25",
  y: "13.5",
  width: "70.167",
  height: "25",
  rx: ".5",
  stroke: "#D2D6DB",
  strokeDasharray: "2 2"
}), /*#__PURE__*/React.createElement("rect", {
  x: "6.5",
  y: "6",
  width: "20.333",
  height: "3.813",
  rx: ".5",
  stroke: "#D2D6DB",
  strokeDasharray: "1.5 1.5"
}), /*#__PURE__*/React.createElement("rect", {
  x: "50.001",
  y: "50.875",
  width: "26.667",
  height: "9.625",
  rx: "2",
  fill: "#59C3C3"
})));